export const heroImages = [
  {
    url: "https://images.unsplash.com/photo-1757264119016-7e6b568b810d?auto=format&fit=crop&w=1920&q=80",
    alt: "Modern contemporary white villa with swimming pool and palm trees"
  },
  {
    url: "https://images.unsplash.com/photo-1770163821178-d1f705ca0952?auto=format&fit=crop&w=1920&q=80",
    alt: "Tavira - Historic town with white buildings and terracotta roofs"
  },
  {
    url: "https://images.unsplash.com/photo-1754221715854-157c677101c5?auto=format&fit=crop&w=1920&q=80",
    alt: "Quinta do Lago - Aerial view of pristine beach with lush vegetation"
  },
  {
    url: "https://images.unsplash.com/photo-1725344153786-22686793e5a3?auto=format&fit=crop&w=1920&q=80",
    alt: "Lagos - Dramatic rock formations and cliffs along the coastline"
  }
];
export const heroImage = heroImages[0].url;
export const aboutImage = "https://images.unsplash.com/photo-1762335358426-72c27db3f5ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxMaXNib24lMjB5ZWxsb3clMjB0cmFtJTIwaGlzdG9yaWMlMjBzdHJlZXQlMjBQb3J0dWdhbHxlbnwwfHx8fDE3NzEwODY4MTV8MA&ixlib=rb-4.1.0&q=85&w=1200";
export const contactImage = "https://images.unsplash.com/photo-1721120135035-7eb316da0fdc?auto=format&fit=crop&w=1200&q=80";

export const content = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      testimonials: "Testimonials",
      contact: "Contact",
      cta: "Get Started"
    },
   hero: {
      titleLine1: "Your Trusted Partner for",
      titleLine2: "Moving to Portugal",
      subtitle: "Expert legal guidance and personalized support for LGBTQIA+ individuals and families investing in their Portuguese dream. We don't just handle paperwork - we build bridges to your new life.",
      cta1: "Schedule Consultation",
      cta2: "Our Services"
    },
     about: {
      tagline: "Who We Are",
      title: "nextStep is a boutique legal practice specializing in immigration, investment, and relocation services for LGBTQIA+ individuals and families choosing Portugal. Founded by attorneys with deep Portuguese legal expertise and lived international experience, we understand both worlds - and we're here to translate not just law, but culture.",
      paragraphs: [
        "We're more than lawyers. We're your concierge for life-changing decisions, your cultural interpreters, and your advocates who genuinely get it. Whether you're escaping uncertainty or embracing opportunity, we provide the legal security, personal attention, and safe harbor you deserve. With us, you're never just a case number - you're part of our community."
      ],
      stats: [
        { number: "300+", label: "Families Supported" },
        { number: "20+", label: "Years Experience" },
        { number: "99%", label: "Success Rate" },
        { number: "24/7", label: "Availability" }
      ],
      whyPortugal: {
        title: "Why Portugal for LGBTQIA+ Families?",
        points: [
          "Same-sex marriage legal since 2010; adoption rights fully recognized",
          "Ranked among the world's most LGBTQIA+-friendly nations (ILGA-Europe)",
          "Strong anti-discrimination laws with constitutional protections",
          "Welcoming expat communities in Lisbon, Porto, and Algarve",
          "Golden Visa, D7, and Digital Nomad pathways to residency and citizenship",
          "High quality of life with affordable living and excellent healthcare"
        ]
      }
   },
    services: {
      tagline: "Comprehensive Services, Personal Touch",
      items: [
        {
          title: "Immigration & Visas:",
          highlight: "Your pathway secured",
          decoration: "red-wavy",
          description: "Golden Visa, D7 Passive Income, Digital Nomad, family reunification, residency permits, and citizenship applications. We handle every detail with technical precision and personal care."
        },
        {
          title: "Real Estate & Investment:",
          highlight: "Smart decisions, safe harbor",
          decoration: "orange-line",
          description: "Property due diligence, purchase contracts, investment structuring, and tax planning. We protect your interests and ensure you're making informed decisions in a foreign market."
        },
        {
          title: "Relocation Concierge:",
          highlight: "Seamless settlement",
          decoration: "yellow-line",
          description: "NIF registration, social security enrollment, bank accounts, healthcare, driver's license conversion, school enrollment. We handle the bureaucracy so you can focus on settling in."
        },
        {
          title: "Family & Personal Law:",
          highlight: "Your rights",
          highlightAccent: "protected",
          decoration: "green-circle",
          description: "Marriage recognition, adoption procedures, parental rights, divorce, custody matters, and estate planning. Specialized expertise in LGBTQIA+ family law and cross-border issues."
        },
        {
          title: "Employment & Business:",
          highlight: "Build your future",
          decoration: "blue-wavy",
          description: "Work permits, employment contracts, company formation, commercial law, and business structuring. Whether you're relocating for work or starting fresh, we've got you covered."
        },
        {
          title: "Community Connection:",
          highlight: "Belong from day one",
          decoration: "magenta-highlight",
          description: "Introductions to LGBTQIA+ organizations, expat networks, and local resources. You're not just moving to Portugal—you're joining a community that welcomes you."
        }
      ]
     },
    testimonials: {
      tagline: "Client Stories",
      title: "Trusted by Families Worldwide",
      subtitle: "Real stories from individuals and couples who trusted us with their life-changing move to Portugal.",
      items: [
        {
          quote: "After the 2024 election, we knew we had to leave the US. nextStep didn't just handle our D7 Visa - they gave us hope and a clear path forward during an uncertain time. Six months later, we're home.",
          name: "Marcus & David Chen",
          location: "San Francisco → Cascais",
          initials: "MD"
        },
        {
          quote: "As a trans woman, I was terrified of the legal complexities and potential discrimination. nextStep treated me with such dignity and professionalism. They knew exactly what I was going through and made everything feel safe.",
          name: "Sarah T.",
          location: "Toronto → Algarve (Faro)",
          initials: "ST"
        },
        {
          quote: "We needed lawyers who understood Brazilian documentation AND Portuguese requirements AND our situation as a same-sex couple with kids. nextStep's team handled it all flawlessly. They even helped us find schools!",
          name: "Maria & Ana Ferreira",
          location: "São Paulo → Algarve (Tavira)",
          initials: "MA"
        }
      ]
    },
    contact: {
      tagline: "Ready to Take the Next Step?",
      title: "Let's Start Your Journey",
      subtitle: "Schedule a confidential consultation (protected by attorney-client legal privilege) to discuss your unique situation and goals. We're available when you need us - even at odd hours across time zones.",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number (optional)",
        service: "Primary Interest",
        serviceOptions: [
          "Golden Visa / Investment Immigration",
          "D7 Visa / Passive Income",
          "Digital Nomad Visa",
          "Family Reunification",
          "Real Estate Purchase",
          "Business Formation",
          "General Consultation"
        ],
        message: "Tell us about your situation and what you're hoping to achieve...",
        submit: "Request Consultation",
        success: "Thank you! We'll respond within 24 hours to schedule your consultation."
      },
      info: {
        address: "Largo de São Luís, nº11 C, 4ºD, 8000-143 Faro",
        email: "hello@nextstep.com.pt",
        phone: "+351 934 229 144",
        hours: "Available 24/7 by appointment"
      },
      messaging: {
        whatsapp: "Chat on WhatsApp",
        whatsappDesc: "Fast response, even outside business hours"
      }
    },
    footer: {
      description: "A boutique consultancy dedicated to LGBTQIA+ individuals and families building new lives in Portugal. We're your bridge, your advocate, your safe harbor.",
      sections: {
        services: "Services",
        company: "Company",
        legal: "Legal"
      },
      serviceLinks: [
        "Immigration & Visas",
        "Real Estate & Investment",
        "Relocation Concierge",
        "Family Law",
        "Employment & Business",
        "Community Connection"
      ],
      companyLinks: ["About Us", "Our Team", "Client Stories", "Contact"],
      legalLinks: ["Privacy Policy", "Terms of Service", "Legal Disclaimer"],
      copyright: "© 2025 nextStep. All rights reserved.",
      disclaimer: "nextStep is a consultancy service owned by a registered legal practice in Portugal. This website provides general information only and does not constitute legal advice. Each case is unique and requires individual consultation."
    }
  },
  pt: {
    nav: {
      about: "Sobre",
      services: "Serviços",
      testimonials: "Testemunhos",
      contact: "Contacto",
      cta: "Começar"
    },
    hero: {
      titleLine1: "O Seu Parceiro de Confiança para",
      titleLine2: "Mudar-se para Portugal",
      subtitle: "Orientação jurídica especializada e apoio personalizado para indivíduos e famílias LGBTQIA+ que investem no seu sonho português. Não tratamos apenas de papelada - construímos pontes para a sua nova vida.",
      cta1: "Agendar Consulta",
      cta2: "Nossos Serviços"
    },
 about: {
      tagline: "Quem Somos",
      title: "A nextStep é um escritório de advocacia boutique especializado em imigração, investimento e serviços de relocalização para indivíduos e famílias LGBTQIA+ que escolhem Portugal. Fundado por advogados com profunda expertise jurídica portuguesa e experiência internacional vivida, entendemos ambos os mundos - e estamos aqui para traduzir não apenas a lei, mas a cultura.",
      paragraphs: [
        "Somos mais do que advogados. Somos o seu concierge para decisões que mudam vidas, os seus intérpretes culturais e os seus advogados que genuinamente entendem. Quer esteja a escapar da incerteza ou a abraçar oportunidades, proporcionamos a segurança jurídica, atenção pessoal e porto seguro que merece. Connosco, nunca é apenas um número de caso - é parte da nossa comunidade."
      ],
      stats: [
        { number: "300+", label: "Famílias Apoiadas" },
        { number: "20+", label: "Anos de Experiência" },
        { number: "99%", label: "Taxa de Sucesso" },
        { number: "24/7", label: "Disponibilidade" }
      ],

      whyPortugal: {
        title: "Porquê Portugal para Famílias LGBTQIA+?",
        points: [
          "Casamento entre pessoas do mesmo sexo legal desde 2010; direitos de adoção totalmente reconhecidos",
          "Classificado entre as nações mais amigas LGBTQIA+ do mundo (ILGA-Europe)",
          "Fortes leis antidiscriminação com proteções constitucionais",
          "Comunidades de expatriados acolhedoras em Lisboa, Porto e Algarve",
          "Caminhos Golden Visa, D7 e Nómada Digital para residência e cidadania",
          "Alta qualidade de vida com custo acessível e excelente saúde"
        ]
      }
    },
    services: {
      tagline: "Serviços Abrangentes, Toque Pessoal",
      items: [
        {
          title: "Imigração & Vistos:",
          highlight: "O seu caminho garantido",
          decoration: "red-wavy",
          description: "Golden Visa, D7 Rendimento Passivo, Nómada Digital, reunificação familiar, autorizações de residência e pedidos de cidadania. Tratamos de cada detalhe com precisão técnica e cuidado pessoal."
        },
        {
          title: "Imobiliário & Investimento:",
          highlight: "Decisões inteligentes, porto seguro",
          decoration: "orange-line",
          description: "Due diligence imobiliária, contratos de compra, estruturação de investimentos e planeamento fiscal. Protegemos os seus interesses e garantimos decisões informadas num mercado estrangeiro."
        },
        {
          title: "Concierge de Relocalização:",
          highlight: "Instalação sem costura",
          decoration: "yellow-line",
          description: "Registo de NIF, inscrição na segurança social, contas bancárias, saúde, conversão de carta de condução, inscrição escolar. Tratamos da burocracia para que possa focar-se em instalar-se."
        },
        {
          title: "Direito Familiar & Pessoal:",
          highlight: "Os seus direitos",
          highlightAccent: "protegidos",
          decoration: "green-circle",
          description: "Reconhecimento de casamento, procedimentos de adoção, direitos parentais, divórcio, questões de custódia e planeamento sucessório. Expertise especializada em direito familiar LGBTQIA+ e questões transfronteiriças."
        },
        {
          title: "Emprego & Negócios:",
          highlight: "Construa o seu futuro",
          decoration: "blue-wavy",
          description: "Autorizações de trabalho, contratos de emprego, constituição de empresas, direito comercial e estruturação de negócios. Quer se esteja a relocalizar por trabalho ou a começar de novo, temos a solução."
        },
        {
          title: "Conexão Comunitária:",
          highlight: "Pertença desde o primeiro dia",
          decoration: "magenta-highlight",
          description: "Apresentações a organizações LGBTQIA+, redes de expatriados e recursos locais. Não está apenas a mudar-se para Portugal—está a juntar-se a uma comunidade que o acolhe."
        }
      ]
    },
    testimonials: {
      tagline: "Histórias de Clientes",
      title: "A Confiança de Famílias em Todo o Mundo",
      subtitle: "Histórias reais de indivíduos e casais que confiaram em nós para a sua mudança de vida para Portugal.",
      items: [
        {
          quote: "Após as eleições de 2024, sabíamos que tínhamos de deixar os EUA. A nextStep não tratou apenas do nosso Golden Visa—deu-nos esperança e um caminho claro durante um tempo incerto. Seis meses depois, estamos em casa.",
          name: "Marcus & David Chen",
          location: "São Francisco → Cascais",
          initials: "MD"
        },
        {
          quote: "Como mulher trans, estava aterrorizada com as complexidades legais e potencial discriminação. A nextStep tratou-me com tanta dignidade e profissionalismo. Sabiam exatamente pelo que estava a passar e fizeram tudo parecer seguro.",
          name: "Sarah T.",
          location: "Toronto → Porto",
          initials: "ST"
        },
        {
          quote: "Precisávamos de advogados que entendessem documentação brasileira E requisitos portugueses E a nossa situação como casal do mesmo sexo com filhos. A equipa da nextStep tratou de tudo impecavelmente. Até nos ajudaram a encontrar escolas!",
          name: "Maria & Ana Ferreira",
          location: "São Paulo → Algarve",
          initials: "MA"
        }
      ]
    },
    contact: {
      tagline: "Pronto para Dar o Próximo Passo?",
      title: "Vamos Começar a Sua Jornada",
      subtitle: "Agende uma consulta confidencial para discutir a sua situação única e objetivos. Estamos disponíveis quando precisar—mesmo fora de horas em fusos horários diferentes.",
      form: {
        name: "Nome Completo",
        email: "Endereço de Email",
        phone: "Número de Telefone (opcional)",
        service: "Interesse Principal",
        serviceOptions: [
          "Golden Visa / Imigração por Investimento",
          "Visto D7 / Rendimento Passivo",
          "Visto Nómada Digital",
          "Reunificação Familiar",
          "Compra Imobiliária",
          "Constituição de Empresa",
          "Consulta Geral"
        ],
        message: "Conte-nos sobre a sua situação e o que espera alcançar...",
        submit: "Solicitar Consulta",
        success: "Obrigado! Responderemos dentro de 24 horas para agendar a sua consulta."
      },
      info: {
        address: "Largo de São Luís, nº11 C, 4ºD, 8000-143 Faro",
        email: "hello@nextstep.com.pt",
        phone: "+351 934 229 144",
        hours: "Disponível 24/7 por marcação"
      },
      messaging: {
        whatsapp: "Conversar no WhatsApp",
        whatsappDesc: "Resposta rápida, mesmo fora do horário comercial"
      }
    },
    footer: {
      description: "Um serviço de consultoria boutique dedicado a indivíduos e famílias LGBTQIA+ construindo novas vidas em Portugal. Somos a sua ponte, o seu advogado, o seu porto seguro.",
      sections: {
        services: "Serviços",
        company: "Empresa",
        legal: "Legal"
      },
      serviceLinks: [
        "Imigração & Vistos",
        "Imobiliário & Investimento",
        "Concierge Relocalização",
        "Direito Familiar",
        "Emprego & Negócios",
        "Conexão Comunitária"
      ],
      companyLinks: ["Sobre Nós", "Nossa Equipa", "Histórias de Clientes", "Contacto"],
      legalLinks: ["Política de Privacidade", "Termos de Serviço", "Aviso Legal"],
      copyright: "© 2025 nextStep. Todos os direitos reservados.",
      disclaimer: "A nextStep é um serviço de consultoria pertencente a um escritório de advocacia registado em Portugal. Este website fornece apenas informação geral e não constitui aconselhamento jurídico. Cada caso é único e requer consulta individual."
    }
  }
};
